var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "node-view-wrapper",
    { staticClass: "banned-word", attrs: { contenteditable: false } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { followCursor: true, placement: "top-center" },
              expression: "{ followCursor: true, placement: 'top-center' }",
            },
          ],
          staticClass: "banned-word-content",
          attrs: { content: "Banned Word" },
        },
        [
          _c("span", { staticClass: "material-icons" }, [_vm._v("cancel")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.node.attrs.word))]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }